/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import React, { useEffect, useState } from "react";
import { Grid } from "@mantine/core";
import ExpertCard from "../experts/ExpertCard";
import ExpertSmallCard from "../experts/ExpertSmallCard";
import { IconAlertCircle } from "@tabler/icons-react";

export default function SingleExpertsDetail({
  dictionary,
  setCount,
  expertsData,
}) {
  useEffect(() => {
    setCount(expertsData?.count ?? 0);
  }, [expertsData]);

  return (
    <>
      <Grid gutter={0}>
        {expertsData?.data?.length == 0 && (
          <div className='my-20 mx-auto text-center'>
            <IconAlertCircle size={100} className='mx-auto text-primary' />
            <div className=' text-[30px] font-semibold text-center text-greyDark mx-auto'>
              {dictionary.noResultsFound}
            </div>
            <p className='text-textGrey'>
              {dictionary.noResultsFoundCheckFilters}
            </p>
          </div>
        )}
        {expertsData?.data?.map((expert, index) => (
          <Grid.Col span={12} md={6} lg={12} m={0} key={expert.id}>
            <div className='hidden lg:block'>
              <ExpertCard
                dictionary={dictionary}
                expert={expert}
                className='my-2'
              />
            </div>
            <div className='block lg:hidden'>
              <ExpertSmallCard
                dictionary={dictionary}
                expert={expert}
                className='m-2'
              />
            </div>
          </Grid.Col>
        ))}
      </Grid>
    </>
  );
}
